import PageCard from './PageCard';

export default PageCard;
